import React, { useEffect } from "react";
import "./Vtec.css";
import Grid from "@mui/material/Grid";
import Navbar from "../../components/Navbar";
import AssetCard from "../../components/Assetcard";
import Searchpanel from "../../components/Searchpanel";
import Freesolo from "../../components/Freesolo";
import { useApp } from "../../hooks/useApp";
import Assetmodal from "../../components/Assetmodal";
import Ipad from "../composable/Ipad";
import MockPc from "../composable/MockPc";
import { useAuth } from "../../hooks/useAuth";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useDocs } from "../../hooks/useDocs";
import utility from "../../Utils/utility";
import { useCollection } from "../../hooks/useCollection";
import Filter from "../../components/Filter";
import ProgressLoader from "../../components/Common/ProgressLoader";
import { useInstances } from "../../hooks/useInstances";

export default function Vtec({ isPreview = false }) {
  const {
    searchState,
    vtecAssets,
    selectedAsset,
    setActiveFactory,
    setActiveMegaFactory,
    setSelectedAsset,
  } = useApp();
  const { updateMultipleDocuments, setUserDeets } = useDocs("partnerDetails");
  const { getAllInstances } = useDocs("demoInstances");
  const { documents: privateAccounts } = useCollection("privateAccounts");
  const theme = useTheme();
  const { user, dispatchUser } = useAuth();
  const { getAccessForInstance } = useInstances();
  const [userVotes, setUserVotes] = useState([]);
  const [assets, setAssets] = useState([]);
  const [voteDetails, setVoteDetails] = useState(null);
  const [, setDemoInstances] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setActiveFactory(null);
    setActiveMegaFactory(null);
    setSelectedAsset(null);
  }, [setActiveFactory, setActiveMegaFactory, setSelectedAsset]);

  useEffect(() => {
    const fetchInstances = async () => {
      try {
        // Check user conditions before looping
        if (user?.isNewUser && user?.emailVerified && user?.approved) {
          setUserDeets(
            user.uid,
            user.email,
            user.emailVerified,
            !user.isNewUser
          );
          const allInstances = await getAllInstances();
          setDemoInstances(allInstances);
          allInstances.forEach((instance) => {
            getAccessForInstance(
              instance.url,
              {
                role: "operator",
                name: user.email,
                badge_id: user.email,
              },
              instance.apiKey,
              instance.secretKey
            );
          });
        }
      } catch (err) {
        console.error("Error fetching demo instances", err);
      }
    };
    fetchInstances(); // Only run if user is available
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user && user?.votes) {
      setUserVotes(user?.votes);
    }
  }, [isPreview, user]);

  let assetList = searchState?.filteredAssets || vtecAssets;

  // const isWithinLast7Days = (date) => {
  //   const now = new Date();
  //   const sevenDaysAgo = new Date();
  //   sevenDaysAgo.setDate(now.getDate() - 7);

  //   return date >= sevenDaysAgo && date <= now;
  // };

  const isWithinLast7Days = (input) => {
    if (!input) return false;

    let date;

    // Firestore Timestamp
    if (typeof input.toDate === "function") {
      date = input.toDate();
    }
    // Firestore object with seconds
    else if (input.seconds) {
      date = new Date(input.seconds * 1000);
    }
    // Already a JS Date
    else if (input instanceof Date) {
      date = input;
    }
    // ISO string
    else if (typeof input === "string") {
      date = new Date(input);
    } else {
      return false;
    }

    const now = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(now.getDate() - 7);

    return date >= sevenDaysAgo && date <= now;
  };

  useEffect(() => {
    if (Array.isArray(assetList) && assetList.length > 0 && privateAccounts) {
      const initialAssets = assetList;
      const newAssets =
        initialAssets &&
        initialAssets.map((item) => {
          const userVoteObj = userVotes.find((vote) =>
            vote.hasOwnProperty(item.id)
          );
          const userVote = userVoteObj ? userVoteObj[item.id] : null;
          let partnerName = "";
          if (item.privateAccount) {
            const opps = privateAccounts.find(
              (opp) =>
                opp.id === item?.privateAccount && opp.isApproved === true
            );
            if (opps && opps.hasOwnProperty("name")) {
              partnerName = opps.name ?? "Partner";
            }
          }
          let isNew = false;
          if (item?.createdAt) {
            isNew = isWithinLast7Days(item.createdAt);
          }
          return {
            ...item,
            userVote,
            partnerName,
            isNew,
          };
        });

      setAssets(newAssets);

      // if (Array.isArray(userVotes) && userVotes.length > 0) {
      // } else {
      //   setAssets(initialAssets);

      // }
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [privateAccounts, searchState?.filteredAssets, userVotes, vtecAssets]);

  const handleVote = (asset, voteType) => {
    let updateUserVotes;
    let removeVote = false;
    let toggleVote = false;
    setUserVotes((prevVotes) => {
      const existingVoteIndex = prevVotes.findIndex((vote) =>
        vote.hasOwnProperty(asset.id)
      );
      const voteValue = voteType === "up";
      if (existingVoteIndex !== -1) {
        const vote = prevVotes[existingVoteIndex];
        if (
          (vote[asset.id] && voteType === "up") ||
          (!vote[asset.id] && voteType === "down")
        ) {
          updateUserVotes = prevVotes.filter(
            (_, index) => index !== existingVoteIndex
          );
          removeVote = true;
        } else if (
          (!vote[asset.id] && voteType === "up") ||
          (vote[asset.id] && voteType === "down")
        ) {
          updateUserVotes = [...prevVotes];
          updateUserVotes[existingVoteIndex] = { [asset.id]: voteValue };
          toggleVote = true;
        } else {
          updateUserVotes = [...prevVotes];
          updateUserVotes[existingVoteIndex] = { [asset.id]: voteValue };
        }
      } else {
        updateUserVotes = [...prevVotes, { [asset.id]: voteValue }];
      }
      return updateUserVotes;
    });
    const { upVote, downVote } = asset;
    let newUpVote = upVote || 0;
    let newDownVote = downVote || 0;
    if (removeVote) {
      if (voteType === "up") newUpVote -= 1;
      else newDownVote -= 1;
    } else if (toggleVote) {
      if (voteType === "up") {
        newUpVote += 1;
        newDownVote -= 1;
      } else {
        newUpVote -= 1;
        newDownVote += 1;
      }
    } else {
      if (voteType === "up") newUpVote += 1;
      else newDownVote += 1;
    }
    setAssets((prevAssets) => {
      return prevAssets.map((item) => {
        if (item.id === asset.id) {
          return {
            ...item,
            upVote: newUpVote,
            downVote: newDownVote,
            userVote: removeVote ? null : voteType === "up" ? true : false,
          };
        }
        return item;
      });
    });
    const updatedAsset = {
      ...asset,
      upVote: newUpVote,
      downVote: newDownVote,
    };
    setVoteDetails({
      asset: updatedAsset,
      removeVote,
      voteType,
      updateUserVotes,
    });
  };

  const updateVoteDetails = utility.debounce(async () => {
    if (voteDetails) {
      const { asset, updateUserVotes } = voteDetails;
      try {
        const updates = [
          {
            collection: "partnerDetails",
            id: user.uid,
            data: { votes: updateUserVotes },
          },
          {
            collection: "vtec_assets",
            id: asset.id,
            data: {
              upVote: asset.upVote,
              downVote: asset.downVote,
            },
          },
        ];
        await updateMultipleDocuments(updates);
        dispatchUser({
          type: "VOTE_CHANGE",
          payload: {
            ...user,
            votes: userVotes,
          },
        });
      } catch (error) {
        console.error("Error updating documents: ", error);
      }
      // Clear voteDetails to avoid re-running this effect
      setVoteDetails(null);
    }
  }, 500);
  useEffect(() => {
    updateVoteDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voteDetails]);
  return (
    <Grid container justifyContent={"center"} className="vtec-container">
      <Navbar sx={{ backgroundColor: "grey" }} />

      <article
        className={`px-6 xl:px-24 w-full sticky top-[65px] z-10 bg-[${theme.palette.background.default}]`}
      >
        <Grid
          container
          className="lg:flex md:!flex-nowrap"
          gap={2}
          paddingY={2}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <article className="md:flex items-center gap-2 md-gap-3 w-full ">
            <Grid item xs className="!mb-3 md:!mb-0">
              <Searchpanel />
            </Grid>
            <Grid item xs>
              <Freesolo />
            </Grid>
            <Grid item xs>
              <Filter />
            </Grid>
          </article>
        </Grid>
      </article>
      <Grid
        className="assets-cards"
        container
        paddingBottom={10}
        sx={{ padding: "0px 10px" }}
      >
        {loader ? (
          <ProgressLoader />
        ) : (
          <Grid container gap={6} justifyContent={"center"} marginTop={2}>
            {assets.length > 0 &&
              assets.map((asset) => {
                return (
                  <AssetCard
                    item
                    key={asset.id}
                    asset={asset}
                    onVoteClick={handleVote}
                  ></AssetCard>
                );
              })}
          </Grid>
        )}
      </Grid>

      {selectedAsset && <Assetmodal />}
      <MockPc />
      <Ipad />
    </Grid>
  );
}
